module.exports = __webpack_public_path__ + "img/view-cloud-animation-1.6ae0d32d.png";